import { useEffect, useRef } from 'react';

import { styles } from './VideoPlayer.styles';

export interface VideoPlayerProps {
  sources: { src: string; media?: string }[];
  width?: number;
  height?: number;
  loop?: boolean;
  className?: string;
  renderCloseButton?: () => React.ReactNode;
  title?: string;
}

export function VideoPlayer({
  sources,
  width = 1440,
  height = 600,
  loop = false,
  className = '',
  renderCloseButton,
  title
}: VideoPlayerProps) {
  const slots = styles();

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.muted = false;
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={slots.base({ className })}>
      <video
        ref={videoRef}
        className={slots.video()}
        width={width}
        height={height}
        controls
        loop={loop}
        muted
        playsInline
        title={title}
      >
        {sources.map((source, index) => (
          <source
            key={index}
            src={source.src}
            media={source.media}
          />
        ))}
      </video>
      {renderCloseButton && (
        <div className={slots.closeButton()}>{renderCloseButton()}</div>
      )}
    </div>
  );
}
